export default [
  {
    type: 'beige',
    background: '--beige200',
  },
  {
    type: 'purple',
    background: '--purple200',
  },
  {
    type: 'green',
    background: '--green200',
  },
  {
    type: 'blue',
    background: '--blue200',
  },
];
